var _g, _path, _polygon, _g2, _path2, _path3, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#87301B",
    d: "M44.687,13.815L20.149,23.55l-1.768,131.967c0,0-0.719,3.797,2.454,5.058 c3.168,1.269,19.419,6.04,19.419,6.04l0.813-133.274L44.687,13.815z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 644.3477,
    y1: 581.4316,
    x2: 695.9316,
    y2: 592.3959,
    gradientTransform: "matrix(0.8619 0.081 -0.0935 0.9956 -485.5345 -545.4648)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#925D37"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0941,
    style: {
      stopColor: "#9C633A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3274,
    style: {
      stopColor: "#B46E39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5587,
    style: {
      stopColor: "#C6763A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7849,
    style: {
      stopColor: "#D17B39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D67E38"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M34.297,19.01l6.84,2.985l-0.883,144.629c0,0-16.25-4.78-19.419-6.04 c-3.173-1.259-2.454-5.054-2.454-5.054L34.297,19.01z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#F7941E",
    points: "44.912,11.385 17.789,157.464 17.789,157.464 19.622,21.426  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#87301B",
    d: "M177.123,33.732c-13.632-3.131-49.94-8.579-49.94-8.579c8.132,4.64,15.023,10.112,20.514,16.471 c13.181,15.573,20.833,46.768,15.898,77.549c-0.235,1.48-0.41,2.913-0.574,4.317c-7.146,19.27-14.77,36.293-21.313,43.008 c-8.159,8.363-21.951,14.806-35.969,15.353l60.732,2.957l21.257-139.958C187.722,44.849,190.755,36.858,177.123,33.732z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 795.5781,
    y1: -552.1924,
    x2: 738.2377,
    y2: -567.5571,
    gradientTransform: "matrix(0.9824 0.1867 0.1867 -0.9824 -486.8373 -599.2655)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#925D37"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0941,
    style: {
      stopColor: "#9C633A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3274,
    style: {
      stopColor: "#B46E39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5587,
    style: {
      stopColor: "#C6763A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7849,
    style: {
      stopColor: "#D17B39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D67E38"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M168.99,164.79l18.731-119.941c0,0,3.033-7.991-10.599-11.117 c-13.632-3.131-49.94-8.579-49.94-8.579c8.132,4.64,15.023,10.112,20.514,16.471c13.181,15.573,20.833,46.768,15.898,77.549 C159.054,147.577,168.99,164.79,168.99,164.79z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7941E",
    d: "M105.607,182.535c14.11-0.549,27.997-7.025,36.213-15.451c18.737-19.206,46.321-122.456,46.321-122.456 l-21.398,140.887L105.607,182.535z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DA8319",
    d: "M96.859,47.665c-9.068-2.308-24.58-4.236-27.729-3.841l-2.943,113.103 c3.003,1.063,7.972,1.589,12.466,2.058c32.65,3.709,55.896-12.296,59.999-51.006C142.455,74.359,127.069,55.364,96.859,47.665z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.95ca6f5c86d02c0ed14da078650c8c50.svg";
export { ForwardRef as ReactComponent };